export const FEAT_ID_HEATER_MATERIAL = 5;
export const FEAT_ID_FILLING_MATERIAL = 14;
export const FEAT_ID_WEIGHT_G = 31;
export const FEAT_ID_REGION = 30;
export const FEAT_ID_PACKAGE_MATERIAL = 37;
export const FEAT_ID_INGREDIENTS = 95;
export const FEAT_ID_DESIRED_EFFECTS = 102;
export const FEAT_ID_FLAVORS = 105;
export const FEAT_ID_ENERGY = 106;
export const FEAT_ID_FAT = 108;
export const FEAT_ID_CARBOHYDRATES = 109;
export const FEAT_ID_CONTAINER_CAPACITY = 111;
export const FEAT_ID_INTENDED_SERVINGS_PER_SKU = 112;
export const FEAT_ID_PACKAGE_OPTIONS = 117;
export const FEAT_ID_PROTEINS = 119;
export const FEAT_ID_WEIGHT_OZ = 122;
export const FEAT_ID_SUGAR = 141;
export const FEAT_ID_PACKAGE_TYPES = 177;
export const FEAT_ID_APPLICATION_AREAS = 623;
// export const FEAT_ID_ = ;

export const PROD_STATUS_ID_UNDER_DEVELOPMENT = 1;
export const PROD_STATUS_ID_TRIAL_PRODUCTION = 2;
export const PROD_STATUS_ID_CONCEPT = 4;
export const PROD_STATUS_ID_PRE_ORDERS = 7;

export const TYPE_ID_USP = 36;
export const TYPE_COMPETITORS_ID = 279;
export const TYPE_ID_IMAGES = 297;

// Competitor types (children of TYPE_COMPETITORS_ID) split into separate W&S filters.
export const TYPE_ID_BIG_TOBACCO = 72;
export const TYPE_ID_ALCS = 276;
export const TYPE_ID_BAT = 273;
export const TYPE_ID_CNTC = 65;
export const TYPE_ID_IMPB = 275;
export const TYPE_ID_JTI = 274;
export const TYPE_ID_KTNG = 280;

export const BIG_TOBACCO_TYPE_IDS = [
  TYPE_ID_BIG_TOBACCO,
  TYPE_ID_ALCS,
  TYPE_ID_BAT,
  TYPE_ID_CNTC,
  TYPE_ID_IMPB,
  TYPE_ID_JTI,
  TYPE_ID_KTNG,
];

export const TYPE_ID_ABBOTT = 343;
export const TYPE_ID_ABINBEV = 317;
export const TYPE_ID_ADM = 318;
export const TYPE_ID_AJINOMOTO = 334;
export const TYPE_ID_CARGILL = 340;
export const TYPE_ID_COCA_COLA = 320;
export const TYPE_ID_DANONE = 321;
export const TYPE_ID_FERRERO_GROUP = 322;
export const TYPE_ID_FOOD_GIANT = 319;
export const TYPE_ID_FOSHAN_HAITIAN = 336;
export const TYPE_ID_FRIESLAND_CAMPINA = 333;
export const TYPE_ID_GENERAL_MILLS = 323;
export const TYPE_ID_GLAXO_SMITH_KLINE = 337;
export const TYPE_ID_HEINEKEN = 324;
export const TYPE_ID_HERSHEY = 325;
export const TYPE_ID_JBS_SA = 342;
export const TYPE_ID_KEURIG_DR_PEPPER = 332;
export const TYPE_ID_KRAFT_HEINZ = 326;
export const TYPE_ID_MARS = 327;
export const TYPE_ID_MEIJI = 339;
export const TYPE_ID_MONDELEZ = 328;
export const TYPE_ID_MONSTER_BEVERAGE = 341;
export const TYPE_ID_NESTLE = 329;
export const TYPE_ID_PEPSICO = 316;
export const TYPE_ID_RED_BULL = 345;
export const TYPE_ID_SUNTORY = 335;
export const TYPE_ID_TYSON_FOODS = 330;
export const TYPE_ID_UNILEVER = 331;
export const TYPE_ID_YAKULT_HONSHA = 338;

export const MAJOR_PLAYERS_TYPE_IDS = [
  TYPE_ID_ABBOTT,
  TYPE_ID_ABINBEV,
  TYPE_ID_ADM,
  TYPE_ID_AJINOMOTO,
  TYPE_ID_CARGILL,
  TYPE_ID_COCA_COLA,
  TYPE_ID_DANONE,
  TYPE_ID_FERRERO_GROUP,
  TYPE_ID_FOOD_GIANT,
  TYPE_ID_FOSHAN_HAITIAN,
  TYPE_ID_FRIESLAND_CAMPINA,
  TYPE_ID_GENERAL_MILLS,
  TYPE_ID_GLAXO_SMITH_KLINE,
  TYPE_ID_HEINEKEN,
  TYPE_ID_HERSHEY,
  TYPE_ID_JBS_SA,
  TYPE_ID_KEURIG_DR_PEPPER,
  TYPE_ID_KRAFT_HEINZ,
  TYPE_ID_MARS,
  TYPE_ID_MEIJI,
  TYPE_ID_MONDELEZ,
  TYPE_ID_MONSTER_BEVERAGE,
  TYPE_ID_NESTLE,
  TYPE_ID_PEPSICO,
  TYPE_ID_RED_BULL,
  TYPE_ID_SUNTORY,
  TYPE_ID_TYSON_FOODS,
  TYPE_ID_UNILEVER,
  TYPE_ID_YAKULT_HONSHA,
];

export const FEAT_GROUP_FLAVORS_AND_EFFECTS = [FEAT_ID_FLAVORS, FEAT_ID_DESIRED_EFFECTS, FEAT_ID_APPLICATION_AREAS];
export const FEAT_GROUP_NP = [FEAT_ID_ENERGY, FEAT_ID_FAT, FEAT_ID_PROTEINS, FEAT_ID_CARBOHYDRATES, FEAT_ID_SUGAR];
export const PROD_STATUS_GROUP_INGREDIENTS_OPTIONAL = [
  PROD_STATUS_ID_CONCEPT,
  PROD_STATUS_ID_UNDER_DEVELOPMENT,
  PROD_STATUS_ID_TRIAL_PRODUCTION,
  PROD_STATUS_ID_PRE_ORDERS,
];

export const FEAT_GROUP_PACKAGE = [
  FEAT_ID_CONTAINER_CAPACITY,
  FEAT_ID_WEIGHT_G,
  FEAT_ID_WEIGHT_OZ,
  FEAT_ID_PACKAGE_MATERIAL,
  FEAT_ID_PACKAGE_TYPES,
  FEAT_ID_PACKAGE_OPTIONS,
];

export default {
  FEAT_ID_FILLING_MATERIAL,
  FEAT_ID_REGION,
  FEAT_ID_HEATER_MATERIAL,
  TYPE_ID_USP,
  TYPE_COMPETITORS_ID,
  TYPE_ID_IMAGES,
};
